export default {
  description: 'Użyj kodu: {{code}}, aby skorzystać ze zniżki na kolejne {{count}} zamówienia składane tutaj.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Zamówienie',
    },
  },
  savings: {
    percentage: 'Łącznie oszczędzasz {{totalSaved}}%',
    fixed: 'Łącznie oszczędzasz {{totalSaved}}',
  },
  apply: 'Zastosuj',
  applied: 'Zastosowano',
  remove: 'Usuń',
  custom_button: {
    done: 'Gotowe',
  },
};
